import React from "react";
import clsx from "clsx";
import styles from "./FormPanel.module.scss";
import { Slot } from "@radix-ui/react-slot";

export interface FormPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  asChild?: boolean;
}

const FormPanel = ({ children, className, asChild, ...props }: FormPanelProps) => {
  const Component = asChild ? Slot : "div";

  return React.createElement(
    Component,
    {
      className: clsx(styles.formPanel, className),
      "data-deci-form-panel": true,
      ...(props as React.HTMLAttributes<HTMLElement>),
    } as React.HTMLAttributes<HTMLElement>,
    children,
  );
};

export interface FormPanelTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

const FormPanelTitle = ({ children, className, ...props }: FormPanelTitleProps) => {
  return (
    <h2 className={clsx(styles.title, className)} {...props}>
      {children}
    </h2>
  );
};

export default Object.assign(FormPanel, {
  Title: FormPanelTitle,
});
